export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxQlgc5ijTjQJElti5.7908096e.woff2";